import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'commaSeparator',
})
export class CommaSeparatorPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}

  transform(value: number): string {
    const finalResult: any = Number(value).toLocaleString('en-IN');
    // console.log(finalResult);
    if (finalResult.toString().includes('.')) {
      return finalResult;
    } else {
      return finalResult + '.00';
    }

    // const numberString = value.toString();
    // if (numberString.includes('.')) {
    //   const decimalPrice = numberString.split('.')[0];
    //   const parts = [];
    //   let i = decimalPrice.length - 1;

    //   // Group the last three digits
    //   if (i >= 2) {
    //     parts.unshift(decimalPrice.substr(i - 2, 3));
    //     i -= 3;
    //   }

    //   // Group the remaining digits by two
    //   while (i >= 0) {
    //     const chunk = decimalPrice.substr(Math.max(0, i - 1), 2);
    //     parts.unshift(chunk);
    //     i -= 2;
    //   }

    //   return parts.join(',') + '.' + numberString.split('.')[1].slice(0, 2);
    // } else {
    //   const parts = [];
    //   let i = numberString.length - 1;

    //   // Group the last three digits
    //   if (i >= 2) {
    //     parts.unshift(numberString.substr(i - 2, 3));
    //     i -= 3;
    //   }

    //   // Group the remaining digits by two
    //   while (i >= 0) {
    //     const chunk = numberString.substr(Math.max(0, i - 1), 2);
    //     parts.unshift(chunk);
    //     i -= 2;
    //   }

    //   return parts.join(',');
  }
}
